import { getState } from '../analytics-state';
import {
  NOT_APPLICABLE, PIP, STASH, ATC, PRODUCT_POD
} from '../constants';

export const fbr = () => {
  window.LIFE_CYCLE_EVENT_BUS.on('feature-based-recommendations.click', ({ output = {} }) => {
    const { index, recommendedFeatureSet, recommendedProductSet } = output;
    const { pageItemId = '' } = getState() || {};
    const ddoEvent = {
      eventInfo: {
        eventName: 'recommendation pip load'
      },
      category: {
        primaryCategory: STASH
      },
      eventMode: STASH,
      stash: {
        recommendation: {
          recommendationType: 'fbr',
          pageType: PIP,
          displayPosition: index + 1,
          anchorProductSku: pageItemId,
          strategy: NOT_APPLICABLE,
          recommendationVersion: recommendedProductSet,
          featureVersion: recommendedFeatureSet,
          interval: NOT_APPLICABLE
        }
      }
    };
    digitalData.event.push(ddoEvent);
  });
  window.LIFE_CYCLE_EVENT_BUS.on('fbr.add-to-cart', ({ output = {} }) => {
    const {
      items = [],
      bundle = false,
      modelName = NOT_APPLICABLE,
      version = NOT_APPLICABLE,
      apiName = NOT_APPLICABLE
    } = output;

    const { pageType = '', pageItemId = '' } = getState() || {};

    const refinedItems = items.map((item, itemIndex) => {
      const { itemId, productId = '', strategy } = item;
      const sku = itemId ? itemId.toString() : productId.toString();
      const itemStrategy = strategy !== undefined ? strategy : NOT_APPLICABLE;
      if (items?.length > 1 && itemId === pageItemId) {
        return {
          productInfo: {
            sku
          }
        };
      }
      return {
        productInfo: {
          sku
        },
        displayPosition: bundle ? NOT_APPLICABLE : itemIndex + 1,
        recommendation: {
          recommendationType: bundle ? 'product bundle' : 'fbr',
          pageType: PIP,
          anchorProductSku: pageItemId,
          strategy: bundle ? modelName : itemStrategy,
          recommendationVersion: bundle ? version : NOT_APPLICABLE,
          featureVersion: NOT_APPLICABLE,
          interval: NOT_APPLICABLE,
        }
      };
    });

    const ddoEvent = {
      eventInfo: {
        eventName: bundle ? 'cart addition info' : 'recommendation cart addition'
      },
      category: {
        primaryCategory: STASH
      },
      eventMode: STASH,
      stash: {
        component: PRODUCT_POD,
        item: refinedItems,
        pageType,
        section: bundle ? 'product bundle' : 'dyn prod rec',
        sharedSection: NOT_APPLICABLE,
        target: ATC
      }
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });
};